module.exports = {
  'Skin and appendages disorders':'Skin and appendages disorders',
  'Musculo-skeletal system disorders':'Musculo-skeletal system disorders',
  'Collagen disease':'Collagen disease',
  'Central and peripheral nervous system disorders':'Central and peripheral nervous system disorders',
  'Vision disorders':'Vision disorders',
  'Hearing and vestibular disorders':'Hearing and vestibular disorders',
  'Psychiatric disorders':'Psychiatric disorders',
  'Gastrointestinal system disorders':'Gastrointestinal system disorders',
  'Kidney and biliary system disorders':'Kidney and biliary system disorders',
  'Metabolic and nutritional disorders':'Metabolic and nutritional disorders',
  'Cardiovascular disorders, general':'Cardiovascular disorders, general',
  'Myocardial, endocardial, pericardial, and valve disorders':'Myocardial, endocardial, pericardial, and valve disorders',
  'Heart rate and rhythm disorders':'Heart rate and rhythm disorders',
  'Vascular (extra-cardiac) disorders':'Vascular (extra-cardiac) disorders',
  'Respiratory system disorders':'Respiratory system disorders',
  'Red blood cell disorders':'Red blood cell disorders',
  'White blood cell and RES disorders':'White blood cell and RES disorders',
  'Platelet, bleeding, and clotting disorders':'Platelet, bleeding, and clotting disorders',
  'Urinary system disorders':'Urinary system disorders',
  'Fetal disorders':'Fetal disorders',
  'Body as a whole – general disorders':'Body as a whole – general disorders'
};
